export interface WalletBalance {
	usd: number
	change: number
	changePercent: number
	isPositive: boolean
}

// TODO: Replace with API call
export const MOCK_WALLET_BALANCE: WalletBalance = {
	usd: 15346.35,
	change: 928.38,
	changePercent: 6.44,
	isPositive: true,
}
